import * as React from "react";
import * as Data from "./data";
import { NOT_SET } from "./need-approval-counter-updater";
import * as NeedSigningCounterUpdater from "./need-approval-counter-updater";
import LeftDrawer from "./left-drawer";

export default class LeftDrawerContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menus: Data.data(this.props.user, NOT_SET, NOT_SET)
    };
  }

  componentDidMount() {
    let u = this.props.user;
    if (
      u &&
      (u.isInApprovalFlow ||
        u.canEditAcquisitionsReports ||
        u.canEditAccountingReports ||
        u.canEditReceptionReports)
    ) {
      NeedSigningCounterUpdater.register(
        (needSigningCounter, newArticlesCounter) => {
          this.setState({
            menus: Data.data(
              this.props.user,
              needSigningCounter,
              newArticlesCounter
            )
          });
        }
      );
    }
  }

  componentWillReceiveProps(newProps) {
    let u = this.props.user;
    if (
      newProps.refreshCounter &&
      u &&
      (u.isInApprovalFlow ||
        u.canEditAcquisitionsReports ||
        u.canEditAccountingReports ||
        u.canEditReceptionReports)
    ) {
      NeedSigningCounterUpdater.fetchCounter(
        (needSigningCounter, newArticlesCounter) => {
          this.setState({
            menus: Data.data(
              this.props.user,
              needSigningCounter,
              newArticlesCounter
            )
          });
        }
      );
    }
  }

  componentWillUnmount() {
    if (this.props.user && this.props.user.isInApprovalFlow) {
      NeedSigningCounterUpdater.unregister();
    }
  }

  render() {
    return (
      <LeftDrawer
        navDrawerOpen={this.props.navDrawerOpen}
        docked={this.props.docked}
        onRequestChange={this.props.onRequestChange}
        onNavigate={this.props.onNavigate}
        menus={this.state.menus}
        username={this.props.username}
        email={this.props.userEmail}
      />
    );
  }
}
